"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Loader = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Spinner, {
    color: "secondary",
    fontSize: "large"
  })
});
exports.Loader = Loader;